<template>
  <zj-layout-container v-if="activeCode == code">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable">
          <el-checkbox-group
            @change="handleCheckedChange"
            v-model="Usersids"
            class="zj-user-list"
          >
            <el-checkbox
              v-for="item in UsersOptions"
              :key="item.id"
              :label="item.id"
              :value="item.id"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form>
  </zj-layout-container>
</template>
<script>
import { queryUserPage } from "../../../apis/src/Query";
import {bus} from '../../../apis/bus.js'

export default {
  name: "ZjTreeItem",
  controller: "UI",
  action: "TreeItem",
  components: {},
  props: {
    code: { type: String },
    activeCode: { type: String, default: '' },
  },
  data() {
    return {
      UsersOptions: [],
      Usersids: [],
      CheckedUserItems: [],
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    getData() {
      queryUserPage({"page":1,"size":999,"name":"","order":"id","sort":"desc","phone":"","organizationCode":this.code}).then(res =>{
        if(res.code == 0){
          this.UsersOptions = res.data
        }else{
          this.errmsg(res.msg);
        }
      })
    },
    handleCheckedChange(ids) {
      let {code} = this;
      this.Usersids = ids;
      bus.$emit('getIds', ({code,ids}))
    },
  },
};
</script>